import React from "react";
import clsx from "clsx";

import * as styles from "./styles/Button.module.css";

export type ButtonVariant = "primary" | "secondary";

// TODO: it's likely that once we have a unified design system for BA, we'll
// want to refine the variants for this component.
type CommonButtonProps = {
	variant?: ButtonVariant;
};

type HTMLButtonProps = CommonButtonProps & React.ComponentProps<"button">;

// href on a is optional by default.  we force it here to differentiate between
// when we should render a button and when we should render an anchor.
type HTMLAnchorProps = CommonButtonProps & {
	href: string;
} & React.ComponentProps<"a">;

type ButtonProps = HTMLButtonProps | HTMLAnchorProps;

const HTMLButton = React.forwardRef<HTMLButtonElement, HTMLButtonProps>(
	function HTMLButton({children, ...props}, ref) {
		return (
			<button {...props} ref={ref}>
				{children}
			</button>
		);
	}
);

const HTMLAnchor = React.forwardRef<HTMLAnchorElement, HTMLAnchorProps>(
	function HTMLAnchor({children, className, ...props}, ref) {
		return (
			<a {...props} className={clsx(styles.linkButton, className)} ref={ref}>
				{children}
			</a>
		);
	}
);

export const Button = React.forwardRef<
	HTMLButtonElement | HTMLAnchorElement,
	ButtonProps
>(function Button({variant = "primary", className, ...props}, ref) {
	// get classes consistent between the two types of buttons
	const classes = clsx(styles.button, styles[variant], className);

	if ("href" in props) {
		return (
			<HTMLAnchor
				{...props}
				className={classes}
				ref={ref as React.Ref<HTMLAnchorElement>}
			/>
		);
	}

	return (
		<HTMLButton
			{...props}
			className={clsx(classes, props.disabled && styles.disabled)}
			ref={ref as React.Ref<HTMLButtonElement>}
		/>
	);
});
